import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as AlertTriangleIcon } from "components/Icons/alert-triangle.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    gridContainer: {
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 24,
    },
    title: {
      fontSize: 24,
      color: theme.gray800,
      margin: 0,
    },
    subtitle: {
      fontSize: 16,
      color: theme.gray500,
      margin: 0,
    },
    button: {
      padding: "16px 32px",
      margin: 10,
      fontWeight: 500,
    },
    icon: {
      width: 48,
      height: 48,
      color: theme.gray500,
    },
  }),
);

export function ErrorFallback() {
  const classes = useStyles();
  const { message } = useMessage();

  const handleRefreshClick = () => {
    window.location.reload();
  };

  return (
    <Grid className={classes.gridContainer}>
      <AlertTriangleIcon className={classes.icon} />
      <p className={classes.title} data-test-id="smth-went-wrong-error-info">
        {message({ id: "oopsSomethingWentWrong" })}
      </p>
      <p className={classes.subtitle}>
        {message({ id: "refreshBrowserInfo" })}
      </p>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleRefreshClick}
      >
        {message({ id: "refreshPage" })}
      </Button>
    </Grid>
  );
}
